exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview {\n  height: 90%;\n}\n@media (max-width: 767px) {\n  .preview {\n    height: auto;\n  }\n}\n.preview-buttons {\n  padding: 20px;\n  text-align: center;\n}\n.preview-buttons .btn {\n  margin-bottom: 5px;\n}\n.preview-buttons a {\n  font-size: 80%;\n  display: none;\n}\n@media (max-width: 767px) {\n  .preview-buttons a {\n    display: inline-block;\n  }\n}\n@media (max-width: 767px) {\n  .preview-buttons {\n    box-shadow: 1px 1px 1px 1px rgba(101, 121, 131, 0.4);\n    position: relative;\n    z-index: 1;\n  }\n}\n.iframe-wrapper {\n  height: 100%;\n  -webkit-overflow-scrolling: touch !important;\n}\n@media (max-width: 767px) {\n  .iframe-wrapper {\n    height: 800px;\n    margin: 0 40px;\n  }\n}\niframe {\n  width: 100%;\n  height: 100%;\n  border-top: 1px grey solid;\n  margin-top: 10px;\n}\n.attachment-link {\n  padding-left: 10px;\n}\n.attachment-link span {\n  color: #8c0949;\n}\n.attachment-link a {\n  font-family: 'Proxima Nova W01', Helvetica, Arial, sans-serif;\n  color: #333;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthewspringbett/sites/rooster/admin/src/app/mailbox-preview/mailbox-preview.component.less
// module id = ../../../../../src/app/mailbox-preview/mailbox-preview.component.less
// module chunks = 1